// Function definitions
const index = function (params) {
    return window.axios.get('/api/fire-extinguishers', {params});
};

const create = function(data) {
    return window.axios.post('/api/fire-extinguishers', data);
};

const update = function(data) {
    return window.axios.put('/api/fire-extinguishers/'+data.id, data);
};

const save = function(data) {
    if (data.id) {
        return update(data);
    }
    return create(data);
};

const get = function(id) {
    return window.axios.get('/api/fire-extinguishers/'+id);
};

const deleteFireExtinguisher = function(id) {
    return window.axios.delete('/api/fire-extinguishers/'+id);
};

export default {
    index,
    create,
    update,
    save,
    get,
    delete: deleteFireExtinguisher,
}


// WEBPACK FOOTER //
// ./resources/assets/js/services/FireExtinguishersService.js